/* global RELEASE_VERSION */
import React from 'react'
import ReactDOM from 'react-dom'
import '../index.scss'
import App from './AppComponent'
import { Provider } from 'react-redux'
import { getStoreConfiguration } from './store/store'
import { configureStore } from 'redux-starter-kit'
import { environment } from './config'
import { Router } from 'react-router-dom'
import routes from './routes'
import { loadableReady } from '@loadable/component'
import 'whatwg-fetch'
import history from './historyObject'
import { getAbTestsFromCookie } from '../../server/shared'

if (environment !== 'development') {
  Sentry.init({
    beforeSend: (event, hint) => {
      const error = hint.originalException
      if (
        error &&
        error.message &&
        error.message.match('Loading CSS chunk') &&
        event.request &&
        event.request.headers &&
        event.request.headers['User-Agent'] &&
        event.request.headers['User-Agent'].match('Mozilla/5.0 (Java) outbrain')
      ) {
        return null
      }

      if (error && error.message && error.message.match(/^Loading chunk /)) {
        event.fingerprint = ['ChunkLoadError: Loading <chunkname> failed.']
      }

      return event
    },
    dsn: 'https://63c3a9e439904e03b5b944a6207f67e2@sentry.io/1440941',
    environment: location.host === 'lifesum.com' ? 'production' : 'staging',
    release: `lifesum-web@${RELEASE_VERSION}`,
  })
}

const store = configureStore(getStoreConfiguration(window.PRELOADED_STATE))
const rootElement = document.getElementById('mount')
const abTests = getAbTestsFromCookie(document.cookie || '')

Promise.all([
  import(/* webpackChunkName: "Throttle" */ 'throttle-debounce'),
  import(/* webpackChunkName: "LocalStorage" */ './store/localStorage'),
]).then(([{ throttle }, storage]) =>
  store.subscribe(
    throttle(1000, () => {
      storage.saveState(store.getState())
    })
  )
)

async function loadPolyfills() {
  if (typeof window.IntersectionObserver === 'undefined') {
    await import('intersection-observer')
  }
}

loadPolyfills().then(() => {
  if (rootElement.hasChildNodes()) {
    loadableReady(() =>
      ReactDOM.hydrate(
        <Provider store={store}>
          <Router history={history}>
            <App
              routes={routes}
              initialData={window.DATA}
              defaultMessages={window.DEFAULT_MESSAGES}
              abTests={abTests}
            />
          </Router>
        </Provider>,
        rootElement
      )
    )
  } else {
    ReactDOM.render(
      <Provider store={store}>
        <Router history={history}>
          <App routes={routes} initialData={window.DATA} abTests={abTests} />
        </Router>
      </Provider>,
      rootElement
    )
  }
})
